//WHERE ARE MY PAGES NATHANIEL ... I NEED MY PAGES NATHANIEL


//import the router
import { NavLink, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { HashRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserView, MobileView } from 'react-device-detect';

//Main pages for non-mobile
import Main from "./components/nonmobile/main";
import Initscreen from "./components/nonmobile/initscreen";
import Content from "./components/nonmobile/content";
import ErrorPage from "./components/nonmobile/error";
import Cookies from "universal-cookie";
import Contentlist from "./components/nonmobile/Contentlisting";
import Loading from "./components/nonmobile/loading";
import Admin from "./components/nonmobile/admin";

//Pages for Mobile
import Mobilemain from "./components/mobile/main"

import { useState } from "react";

function DesktopLayout() {
  return (
    <ErrorBoundary FallbackComponent={<ErrorPage />}>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/initscreen" element={<Initscreen />} />
        <Route path="/Content" element={<Content />} />
        <Route path="/contentlist" element={<Contentlist />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/admin" element={<Admin />} />
        <Route
          path="*"
          element={
            <ErrorPage
              error="Error - 404"
              information="Unkown request please return to homepage at Projectshard.xyz"
            />
          }
        />
      </Routes>
    </ErrorBoundary>
  );
}

function MobileLayout() {
return(
    <ErrorBoundary FallbackComponent={<ErrorPage />}>
    <Routes>
      <Route path="/" element={<Mobilemain />} />
      <Route
        path="*"
        element={
          <ErrorPage
            error="Error - 404"
            information="Unkown request please return to homepage at Projectshard.xyz"
          />
        }
      />
    </Routes>
  </ErrorBoundary>
)

}




function App() {
  return(

      <>
    <BrowserView>
      <DesktopLayout />
    </BrowserView>
    <MobileView>
      <MobileLayout />
    </MobileView>

  </>
  )



}

export default App;
